/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, OnDestroy} from '@angular/core';
import {VerticalNavIconService} from './providers/vertical-nav-icon.service';
export class VerticalNavIcon implements OnDestroy {
/**
 * @param {?} _verticalNavIconService
 */
constructor(private _verticalNavIconService: VerticalNavIconService) {
        this._verticalNavIconService.registerIcon();
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this._verticalNavIconService.unregisterIcon();
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrVerticalNavIcon]", host: {"class": "nav-icon"}}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: VerticalNavIconService, },
];
}

function VerticalNavIcon_tsickle_Closure_declarations() {
/** @type {?} */
VerticalNavIcon.decorators;
/**
 * @nocollapse
 * @type {?}
 */
VerticalNavIcon.ctorParameters;
/** @type {?} */
VerticalNavIcon.prototype._verticalNavIconService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
